import moment from 'moment';
import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';
import {existOpenOrCloseOrders} from '../utils/commonUtils';


const isTomorrowBlocked = () => {
  const now = moment();
  const noon = moment().hours(12).minutes(0).seconds(0);
  const midnight = moment().hours(23).minutes(59).seconds(59);
  return now.isBetween(noon, midnight);
};

const INITIAL_STATE = {
  'loading': false,
  'loadingOrders': false,
  'loadingFreeDates': false,
  'loadingCombos': false,
  'loadingUpdateDates': false,
  'loadingUpdateCombos': false,
  'loadingDeleteDates': false,
  'freeDates': [],
  'data': [],
  'combos': [],
  'selectedVehicleCombo': null,
  'selectedVehicleAgency': {
    'chassis': '',
    'dealerDestiny': '',
    'agency': '',
  },
  'ordersByDate': [],
  'updateSuccess': false,
  'loadingUpdateAgency': false,
  'loadingAgency': false,
  'suggestedDatesData': null,
  'loadingSuggestedDates': false,
};

export const priorizationDates = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_GET_PRIORIZATION_DATES]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_GET_PRIORIZATION_DATES]: (state, action) => ({
      ...state,
      'loading': false,
      'data': action.response.data.map((line) => ({
        ...line,
        'isSelected': false,
        'haveOpenCloseOrders': existOpenOrCloseOrders(line),
      })),
    }),
    [ActionTypes.FETCH_GET_PRIORIZATION_DATES_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.FETCHING_GET_ORDERS_BY_DATE]: (state, action) => ({
      ...state,
      'loadingOrders': true,
    }),
    [ActionTypes.FETCHED_GET_ORDERS_BY_DATE]: (state, action) => ({
      ...state,
      'loadingOrders': false,
      'ordersByDate': action.response.data,
    }),
    [ActionTypes.FETCH_GET_ORDERS_BY_DATE_FAILED]: (state, action) => ({
      ...state,
      'loadingOrders': false,
    }),
    [ActionTypes.CLEAN_ORDERS_BY_DATE]: (state, action) => ({
      ...state,
      'ordersByDate': [],
    }),
    [ActionTypes.FETCH_FREE_DATES_LOGISTIC]: (state, action) => ({
      ...state,
      'loadingFreeDates': true,
    }),
    [ActionTypes.FETCHED_FREE_DATES_LOGISTIC]: (state, action) => {
      const today = [moment().toDate()];
      const tomorrow = isTomorrowBlocked() ? [moment().add(1, 'days').toDate()] : [];
      const blockedDates = action.response.data.length ?
        action.response.data.map((date) => moment(date.date).toDate()) :
        [];
      
      return ({
        ...state,
        'loadingFreeDates': false,
        'freeDates': [...today, ...tomorrow, ...blockedDates],
      });
    },
    [ActionTypes.FETCH_FREE_DATES_LOGISTIC_FAILED]: (state, action) => ({
      ...state,
      'loadingFreeDates': false,
    }),
    [ActionTypes.FETCHING_PRIORIZATION_COMBOS]: (state, action) => ({
      ...state,
      'loadingCombos': true,
    }),
    [ActionTypes.FETCHED_PRIORIZATION_COMBOS]: (state, action) => ({
      ...state,
      'loadingCombos': false,
      'combos': action.response.data,
    }),
    [ActionTypes.FETCH_PRIORIZATION_COMBOS_FAILED]: (state, action) => ({
      ...state,
      'loadingCombos': false,
    }),
    [ActionTypes.SET_SELECTED_VEHICLE_COMBO]: (state, action) => ({
      ...state,
      'selectedVehicleCombo': action.payload,
    }),
    
    [ActionTypes.UPDATE_ORDERS_AMOUNT_BY_DATE]: (state, action) => ({
      ...state,
      'loadingUpdateDates': true,
    }),
    [ActionTypes.UPDATED_ORDERS_AMOUNT_BY_DATE]: (state, action) => ({
      ...state,
      'loadingUpdateDates': false,
      'updateSuccess': !state.updateSuccess,
    }),
    [ActionTypes.UDATE_ORDERS_AMOUNT_BY_DATE_FAILED]: (state, action) => ({
      ...state,
      'loadingUpdateDates': false,
      'updateSuccess': !state.updateSuccess,
    }),
    
    [ActionTypes.REMOVE_VEHICLES_PRIORIZATION]: (state, action) => ({
      ...state,
      'loadingUpdateDates': true,
    }),
    [ActionTypes.REMOVED_VEHICLES_PRIORIZATION]: (state, action) => ({
      ...state,
      'loadingUpdateDates': false,
      'updateSuccess': !state.updateSuccess,
    }),
    [ActionTypes.REMOVE_VEHICLES_PRIORIZATION_FAILED]: (state, action) => ({
      ...state,
      'loadingUpdateDates': false,
      
    }),

    [ActionTypes.UPDATE_VEHICLE_COMBO]: (state, action) => ({
      ...state,
      'loadingUpdateCombos': true,
    }),
    [ActionTypes.UPDATED_VEHICLE_COMBO]: (state, action) => ({
      ...state,
      'loadingUpdateCombos': false,
      'updateSuccess': !state.updateSuccess,
    }),
    [ActionTypes.UPDATE_VEHICLE_COMBO_FAILED]: (state, action) => ({
      ...state,
      'loadingUpdateCombos': false,
    }),

    [ActionTypes.DELETING_DATES_PRIORIZATION]: (state, action) => ({
      ...state,
      'loadingDeleteDates': true,
    }),
    [ActionTypes.DELETE_DATES_PRIORIZATION]: (state, action) => ({
      ...state,
      'loadingDeleteDates': false,
      'updateSuccess': !state.updateSuccess,
    }),
    [ActionTypes.DELETE_DATES_PRIORIZATION_FAILED]: (state, action) => ({
      ...state,
      'loadingDeleteDates': false,
      'updateSuccess': !state.updateSuccess,
    }),
    [ActionTypes.SET_SELECTED_VEHICLE_AGENCY]: (state, action) => ({
      ...state,
      'selectedVehicleAgency': action.payload,
    }),
    [ActionTypes.UPDATED_VEHICLE_AGENCY]: (state, action) => ({
      ...state,
      'updateSuccess': !state.updateSuccess,
    }),
    [ActionTypes.FETCHING_SUGGESTED_PRIORIZATION_DATES]: (state, action) => ({
      ...state,
      'loadingSuggestedDates': true,
    }),
    [ActionTypes.FETCHED_SUGGESTED_PRIORIZATION_DATES]: (state, action) => ({
      ...state,
      'loadingSuggestedDates': false,
      'suggestedDatesData': action.response.data,
    }),
    [ActionTypes.FETCHED_SUGGESTED_PRIORIZATION_DATES_FAILED]: (state, action) => ({
      ...state,
      'loadingSuggestedDates': false,
      'suggestedDatesData': null,
    }),
    [ActionTypes.CLEAN_SUGGESTED_PRIORIZATION_DATES]: (state, action) => ({
      ...state,
      'loadingSuggestedDates': false,
      'suggestedDatesData': null,
    }),
    [ActionTypes.SAVING_PRIORIZATION]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.SAVED_PRIORIZATION]: (state, action) => ({
      ...state,
      'loading': false,
      'data': action.response.data.data.map((line) => ({
        ...line,
        'isSelected': false,
        'haveOpenCloseOrders': existOpenOrCloseOrders(line),
      })),
    }),
    [ActionTypes.SAVED_PRIORIZATION_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.SAVING_LOGISTIC_OBSERVATION]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.SAVED_LOGISTIC_OBSERVATION]: (state, action) => ({
      ...state,
      'loading': false,
      'updateSuccess': !state.updateSuccess,
    }),
    [ActionTypes.SAVED_LOGISTIC_OBSERVATION_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
  })(state, action);
};
